
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hex-color-picker-from-image",
      function () {
        return require("private-next-pages/hex-color-picker-from-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hex-color-picker-from-image"])
      });
    }
  